import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { Base, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { LoginFooter } from './components/LoginFooter/index.js';
import { HeaderDescription } from '../../components/common/HeaderDescription/index.js';
import { LoginWithEmailForm } from './components/LoginWithEmailForm/LoginWithEmailForm.js';
import { LoginWithGoogle } from './components/Socials/LoginWithGoogle.js';
import { LoginWithFacebook } from './components/Socials/LoginWithFacebook.js';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { LoginConsent } from './components/LoginConsent/index.js';
import { SocialsWrapper } from '../../components/common/SocialsWrapper/index.js';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/index.js';
import { loginSourceSelector } from '../../core/sourceData/sourceDataSlice.js';
import { hasSocialAuthConsent } from '../../core/consent/consentSlice.js';
import { LoginNegativeAlert } from './components/LoginNegativeAlert/index.js';
import { sendGlobalTrackingThunk } from '../../core/thunks.js';
import { useTranslatedSourceOverrideLabel } from '../../hooks/useTranslatedLabel.js';
import { trackModalView } from '../../tracking/index.js';
import { navigationActions, selectNavigationContext, } from '../../core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { ChangeEmailAlert } from './components/ChangeEmailAlert/index.js';
import { emailChangeAlertStatusSelector, setEmailChangeAlertStatus, } from './loginSlice.js';
import { storageKeys } from '../../constants/storageKeys.js';
import { PasswordResetSuccessAlert } from './components/PasswordResetSuccessAlert/index.js';
import { INITIAL_TRACKING_DELAY } from '../../constants/tracking.js';
export const LoginForm = () => {
    const { t } = useTranslation();
    const loginSource = useAppSelector(loginSourceSelector);
    const emailChangeAlert = useAppSelector(emailChangeAlertStatusSelector);
    const hasSocialAuthConsentAccepted = useAppSelector(hasSocialAuthConsent);
    const navigationContext = useAppSelector(selectNavigationContext);
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const dispatch = useAppDispatch();
    const headerLabel = useSourceOverrideLabel('login.header');
    const descriptionLabel = useSourceOverrideLabel('login.body');
    useEffect(() => {
        const isEmailChangeSuccessful = sessionStorage.getItem(storageKeys.isEmailChangeSuccessful) === 'true';
        if (isEmailChangeSuccessful) {
            dispatch(setEmailChangeAlertStatus(isEmailChangeSuccessful));
        }
        if (navigationContext === 'modal') {
            dispatch(navigationActions.setActiveForm(FORM_TYPES.LOGIN));
            // setTimeout to keep correct tracking events order
            setTimeout(() => dispatch(sendGlobalTrackingThunk(trackModalView)), INITIAL_TRACKING_DELAY);
        }
        else {
            dispatch(navigationActions.setActiveForm(FORM_TYPES.LOGIN));
        }
    }, []);
    const searchParams = useSearchParams();
    const isPasswordReset = searchParams && searchParams.get('passwordReset') === '1';
    const onDismissEmailChanged = () => {
        dispatch(setEmailChangeAlertStatus(false));
        sessionStorage.removeItem(storageKeys.isEmailChangeSuccessful);
    };
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "login-form", children: [_jsx(ChangeEmailAlert, { isVisible: emailChangeAlert, onDismiss: onDismissEmailChanged }), isPasswordReset && _jsx(PasswordResetSuccessAlert, {}), _jsx(ContentHeading, { label: headerLabel }), _jsx(HeaderDescription, { label: descriptionLabel }), _jsx(LoginNegativeAlert, {}), _jsx(LoginWithEmailForm, {}), hasSocialAuthConsentAccepted && (_jsx(Base, { pt: 'spaceS', children: _jsxs(SocialsWrapper, { children: [_jsx(LoginWithGoogle, {}), _jsx(LoginWithFacebook, {})] }) })), _jsx(LoginConsent, {}), _jsx(LoginFooter, {})] }));
};
//# sourceMappingURL=LoginForm.js.map